import { Component, OnInit, Output, Input, OnChanges } from "@angular/core";
import { UserManager } from "../../Services/UserManager/user-manager";
import {
  trigger,
  state,
  transition,
  animate,
  style,
} from "@angular/animations";
import { AngularFireDatabase } from "@angular/fire/database";
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from "@angular/fire/firestore";
import { ConversationMeta } from "../../Models/conversation.interface";
import { EventEmitter } from "@angular/core";
import { Profile } from "../../Models/profile.interface";
import { Subscription, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import "firebase/firestore";
import { AUTOREPLIES, NOTIFY, PROFILES } from "src/Constants";
import _ from "lodash";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MessageSheetComponent } from "../message-sheet/message-sheet.component";
import { EmailNotification } from "src/app/Models/Notify.interface";
import { AutoReply } from "src/app/Models/autoreply.interface";
@Component({
  selector: "app-volunteer",
  templateUrl: "./volunteer.component.html",
  styleUrls: ["./volunteer.component.scss"],
  animations: [
    trigger("trigger", [
      state("void", style({ opacity: 0 })),
      state("show", style({ opacity: 1 })),
      transition("void => *", [animate("300ms ease-in-out")]),
      transition("* => void", [animate("300ms ease-in-out")]),
    ]),
    trigger("chooseLimitTrigger", [
      state(
        "void",
        style({ opacity: 0, width: 0, transform: "translateY(-10px)" })
      ),
      state(
        "show",
        style({ opacity: 1, width: "*", transform: "translateY(0)" })
      ),
      transition("void => *", [animate("100ms ease-in-out")]),
      transition("* => void", [animate("100ms ease-in-out")]),
    ]),
    trigger("auto", [
      state(
        "void",
        style({ opacity: 0, height: 0, transform: "translateX(-10px)" })
      ),
      state(
        "show",
        style({ opacity: 1, width: "*", transform: "translateX(0)" })
      ),
      transition("void => *", [animate("100ms ease-in-out")]),
      transition("* => void", [animate("100ms ease-in-out")]),
    ]),
    trigger("item", [
      transition(":enter", [
        style({ height: 0, transform: "translateY(10px)", opacity: 0 }),
        animate(
          "300ms",
          style({ height: "*", transform: "translateY(0)", opacity: 1 })
        ),
      ]),
      transition(":leave", [
        style({ height: "*", transform: "translateY(0)", opacity: 1 }),
        animate(
          "100ms",
          style({ height: 0, transform: "translateY(10px)", opacity: 0 })
        ),
      ]),
    ]),
  ],
})
export class VolunteerComponent implements OnInit, OnChanges {
  @Input() reload: string;
  @Input() uid: string;
  @Input() orgId: string;
  @Input() entityId: string;
  @Input() authLevel: string;
  @Output() choice = new EventEmitter<ConversationMeta>();
  profileSubject;
  profile: Profile;
  currentState = "void";
  limitTrigger = "void";
  autoReplyTrigger = "void";
  autoReplyBody = "";
  autoReplies = [];
  conversations;
  filterFunction;

  ascending: OrderByDirection = "desc"; // 'asc'
  pages: Array<any>;
  total;
  filter;
  order;
  _order;
  needsReset;
  hasNextPage: boolean;
  hasLastPage: boolean;
  conversationsRef: AngularFirestoreCollection<ConversationMeta>;
  unclaimed;
  instructorToFind: string;
  unreadMessages;
  showSystem = false;
  sub: Subscription;
  leaving = new Subject<null>();
  instructors = {};
  profiles = {};
  displayedColumns: string[];
  limit = 220;
  pageIndex = 0;
  selectedAutoReply: AutoReply; // when set, this will show the whole auto reply

  constructor(
    private um: UserManager,
    private db: AngularFireDatabase,
    private _bottomSheet: MatBottomSheet,
    private afs: AngularFirestore
  ) {}
  ngOnChanges(changes) {
    this.filterFunction && this.filterFunction();
  }

  nextPage() {
    this.pageIndex += 1;
    this.getConversations();
  }
  lastPage() {
    if (this.pageIndex > 0) {
      this.pageIndex -= 1;
      this.getConversations();
    }
  }

  ngOnInit() {
    this.profileSubject = this.um.getProfileSubject();
    this.profileSubject.subscribe((profile) => {
      if (!!profile) {
        // migrate away from creator and add in to
        // this is so instructors can send messages to
        // their students

        if (!profile.toMigration && !this.authLevel) {
          this.afs
            .collection<ConversationMeta>("Conversations", (ref) =>
              ref.where("creator", "==", profile.uid)
            )
            .snapshotChanges()
            .takeUntil(this.leaving)
            .subscribe((snap) => {
              snap.forEach(async (dca) => {
                try {
                  await dca.payload.doc.ref.update({ to: profile.uid });
                  // console.log(profile.uid)
                } catch (e) {
                  console.error(e);
                }
              });
            });
          this.afs
            .collection(PROFILES)
            .doc(profile.uid)
            .update({ toMigration: true });
        }

        this.profile = profile;
        if (!this.entityId && !!profile) {
          this.entityId = profile.entityId;
        }
        this.currentState = "show";
        if (this.authLevel) {
          this.setFilterFunction(this.getDefaultInstructor);
          this.displayedColumns = [
            "name",
            "instructor",
            "message",
            "claimed",
            "date",
            "more",
          ];

          // autoreplies

          this.authLevel &&
            this.afs
              .collection(PROFILES)
              .doc(profile.uid)
              .collection<AutoReply>(AUTOREPLIES)
              .snapshotChanges()
              .takeUntil(this.leaving)
              .subscribe((actions) => {
                this.autoReplies = [];
                actions.forEach((action) => {
                  const key = action.payload.doc.id;
                  const data = action.payload.doc.data();
                  const reply = { key, ...data };
                  this.autoReplies.push(reply);
                });
              });

          // console.log(this.autoReplies)

          let obs2 = this.afs
            .collection<ConversationMeta>(
              "Conversations",
              (ref) =>
                ref
                  .orderBy("creator", "asc")
                  .where("instructor", "==", null)
                  .where("lastMessage.system", "==", false)
                  .where("entityId", "==", `${this.entityId}`)
              // .startAfter(this.limit * (this.pageIndex))
            )
            .valueChanges();

          obs2
            .pipe(takeUntil(this.leaving))
            .subscribe((unclaimed) => (this.unclaimed = unclaimed.length));
        } else {
          this.setFilterFunction(this.getDefaultStudent);
          this.displayedColumns = ["name", "message", "date"];
        }

        // get unread messages
        if (!this.sub) {
          this.sub = this.db
            .object(`UnreadMessages/${profile.uid}`)
            .valueChanges()
            .takeUntil(this.leaving)
            .subscribe((unread) => (this.unreadMessages = unread));
        }
      } else {
        this.unreadMessages = null;
        this.leaving.next(null);
      }
    });
  }

  openBottomSheet(event, conversation): void {
    event.stopPropagation();
    const conversationRef = this.afs
      .collection("Conversations")
      .doc(conversation.key);
    this._bottomSheet.open(MessageSheetComponent, {
      data: {
        conversation,
        conversationRef,
        instructor: this.profile,
        orgId: this.profile.organization,
      },
    });
  }

  setSelectedAutoReply(reply: AutoReply) {
    this.selectedAutoReply = reply;
  }

  clearSelectedAutoReply() {
    this.selectedAutoReply = null;
  }

  toggleAutoReplyTrigger() {
    this.autoReplyTrigger = this.autoReplyTrigger === "void" ? "show" : "void";
  }

  createNewAutoReply() {
    if (!this.uid) {
      return;
    }
    if (this.autoReplyBody.trim() === "") {
      alert("You need to have both a Title and a Body");
      return;
    }

    this.afs
      .collection(PROFILES)
      .doc(this.uid)
      .collection(AUTOREPLIES)
      .add({ body: this.autoReplyBody });
    this.autoReplyBody = "";
  }

  deleteReply(reply) {
    if (!this.uid) {
      return;
    }
    this.afs
      .collection(PROFILES)
      .doc(this.uid)
      .collection(AUTOREPLIES)
      .doc(reply.key)
      .delete();
  }

  tracked(item) {
    return item.key;
  }

  getConversations(index = null) {
    if (!this.uid) {
      return;
    }
    if (this.filterFunction) {
      this.filterFunction();
    }
  }

  setFilterFunction(func) {
    if (this.filterFunction === func && this.filterFunction === null) {
      return;
    }
    if (this.filterFunction === func && this.filterFunction !== null) {
      this.getConversations();
      return;
    }
    if (this.filterFunction !== func && func) {
      this.filterFunction = null;
      this.filterFunction = func;
      this.getConversations(0);
    }
  }

  _getData(conversationsRef: AngularFirestoreCollection<ConversationMeta>) {
    if (this.authLevel) {
      this.conversations = conversationsRef.valueChanges().map((convos) => {
        convos.forEach((convo) => this.extractProfile(convo));
        return convos;
      });
    } else {
      this.conversations = conversationsRef.valueChanges().map((convos) => {
        return convos;
      });
    }
  }

  extractProfile(convo) {
    if (convo.lastMessage && convo.lastMessage.originalCreator) {
      const creator = convo.lastMessage.originalCreator;
      // check to see if we have this uid already
      if (!this.profiles[creator.key]) {
        this.afs
          .doc<Profile>(`${PROFILES}/${creator.key}`)
          .valueChanges()
          .takeUntil(this.leaving)
          .subscribe((profile) => {
            if (!profile) {
              return;
            }
            this.profiles[profile.uid] = {};
            this.profiles[profile.uid].firstname = profile.firstname;
            this.profiles[profile.uid].lastname = profile.lastname;
            this.profiles[profile.uid].uid = profile.uid;
            this.profiles[profile.uid].instructor = profile.instructor;
            // if(!profile.instructor && !profile.isInstructor && convo.instructor){
            //   this.db.database.ref('profile')
            //   .child(profile.uid)
            //   .child('instructor')
            //   .set(convo.instructor)
            // }
          });
      }
    }
  }

  // *****Filter Functions*****
  getDefaultInstructor() {
    const conversationsRef = this.afs.collection<ConversationMeta>(
      "Conversations",
      (ref) =>
        ref
          .orderBy("latestUpdate", this.ascending)
          // .orderBy('createdDate', this.ascending)
          .where("entityId", "==", `${this.entityId}`)
          .where("lastMessage.system", "==", false)
          // .startAfter(this.limit * (this.pageIndex))
          .limit(this.limit)
    );
    this._getData(conversationsRef);
    this.orderByClaimed();
    this.needsReset = false;
  }

  showUnclaimed() {
    if (!this.uid) {
      return;
    }
    this.setFilterFunction(this._showUnclaimed);
    this.needsReset = true;
  }

  _showUnclaimed() {
    this.order = "Filter by: Unclaimed";
    this._order = "Unclaimed";
    const conversationsRef = this.afs.collection<ConversationMeta>(
      "Conversations",
      (ref) =>
        ref
          .orderBy("creator", this.ascending)
          .where("instructor", "==", null)
          .where("lastMessage.system", "==", false)
          .where("entityId", "==", `${this.entityId}`)
          // .startAfter(this.limit * (this.pageIndex))
          .limit(this.limit)
    );
    this._getData(conversationsRef);
  }

  getDefaultStudent() {
    if (!this.uid) {
      return;
    }
    const conversationsRef = this.afs.collection<ConversationMeta>(
      "Conversations",
      (ref) =>
        ref

          .where("to", "==", `${this.uid}`)
          // .where('lastMessage.system', '==', false)
          // .where("entityId", "==", `${this.entityId}`)
          // .startAfter(this.limit * (this.pageIndex))
          .orderBy("latestUpdate", this.ascending)
          .limit(this.limit)
    );
    this._getData(conversationsRef);
    this.needsReset = false;
  }

  reset() {
    this.ascending = "desc";
    this.order = "";
    this._order = "";
    if (this.authLevel) {
      this.setFilterFunction(this.getDefaultInstructor);
    } else {
      this.setFilterFunction(this.getDefaultStudent);
    }
  }

  orderBySystem() {
    this.setFilterFunction(this._orderBySystem);
    this.needsReset = true;
  }
  _orderBySystem() {
    if (!!this.authLevel) {
      const conversationsRef = this.afs.collection<ConversationMeta>(
        "Conversations",
        (ref) =>
          ref
            .orderBy("createdDate", this.ascending)
            .where("lastMessage.system", "==", true)
            .where("entityId", "==", `${this.entityId}`)
            .limit(this.limit)
      );
      this._getData(conversationsRef);
    }
  }

  orderByDate() {
    // set filter function is necessary.  filter calls getConvos...which will call _orderByDate
    // console.log(this.pageIndex)
    this.setFilterFunction(this._orderByDate);
    this.needsReset = true;
  }

  _orderByDate() {
    // console.log(this.limit * this.pageIndex)
    this.order =
      this.ascending == "desc"
        ? "Order by: Newest First"
        : "Order by: Oldest First";
    this._order = "Date";
    if (!this.authLevel) {
      const conversationsRef = this.afs.collection<ConversationMeta>(
        "Conversations",
        (ref) =>
          ref
            .orderBy("latestUpdate", this.ascending)
            .where("creator", "==", `${this.uid}`)
            .where("lastMessage.system", "==", false)
            .where("entityId", "==", `${this.entityId}`)
            // .startAfter(this.limit * (this.pageIndex))
            .limit(this.limit)
      );
      this._getData(conversationsRef);
    } else if (this.authLevel) {
      if (this.authLevel) {
        const conversationsRef = this.afs.collection<ConversationMeta>(
          "Conversations",
          (ref) =>
            ref
              .orderBy("latestUpdate", this.ascending)
              .where("lastMessage.system", "==", false)
              .where("entityId", "==", `${this.entityId}`)
              // .startAfter(this.limit * (this.pageIndex))
              .limit(this.limit)
          // .where('creator', '==', `${this.uid}`)
        );
        this._getData(conversationsRef);
      }
    }
  }

  orderByInstructor() {
    // set filter function is necessary.  filter calls getConvos...which will call the _ function
    this.setFilterFunction(this._orderByInstructor);
    this.needsReset = true;
  }

  _orderByInstructor() {
    this.order = "Order by: Instructor";
    this._order = "Instructor";
    if (this.authLevel) {
      const conversationsRef = this.afs.collection<ConversationMeta>(
        "Conversations",
        (ref) =>
          ref
            // .orderBy('instructor', this.ascending)
            .orderBy("latestUpdate", this.ascending)
            .where("entityId", "==", `${this.entityId}`)
            .where("lastMessage.system", "==", false)
            // .startAfter(this.limit * (this.pageIndex))
            .limit(this.limit)
        // .where('creator', '==', `${this.uid}`)
      );
      this._getData(conversationsRef);
    }
  }

  orderByClaimed() {
    this.setFilterFunction(this._orderByClaimed);
    this.needsReset = true;
  }

  _orderByClaimed() {
    if (this.authLevel) {
      var instructor;
      if (!this.instructorToFind) {
        instructor = this.uid;
        this.order = "Filter by: My Claims";
        this._order = "My Claims";
      } else {
        instructor = this.instructorToFind;
        this.order = "Filter by: Claim";
        this._order = "Claim";
      }
      const conversationsRef = this.afs.collection<ConversationMeta>(
        "Conversations",
        (ref) =>
          ref
            .orderBy("createdDate", this.ascending)
            .orderBy("latestUpdate", this.ascending)
            .where("instructor", "==", `${instructor}`)
            .where("lastMessage.system", "==", false)
            .where("entityId", "==", `${this.entityId}`)
            // .startAfter(this.limit * (this.pageIndex))
            .limit(this.limit)
      );
      this._getData(conversationsRef);
    }
  }

  orderByName() {
    this.setFilterFunction(this._orderByName);
    this.needsReset = true;
  }

  _orderByName() {
    // shhhh....dont tell them we are sorting by uid...uids are unique :)
    this.order = "Order by: Name";
    this._order = "Name";
    if (this.authLevel) {
      const conversationsRef = this.afs.collection<ConversationMeta>(
        "Conversations",
        (ref) =>
          ref
            .orderBy("originalCreator.firstname", this.ascending)
            .where("entityId", "==", `${this.entityId}`)
            .limit(this.limit)
      );
      this._getData(conversationsRef);
    }
  }

  toggleDateFilter(event) {
    event.stopPropagation();
    this.ascending = this.ascending == "asc" ? "desc" : "asc";
    // this.orderByDate()
    this.getConversations();
  }

  select(conversation: ConversationMeta) {
    if (!this.uid || !conversation.lastMessage) {
      return;
    }
    if (!conversation.lastMessage.read[this.uid]) {
      conversation.lastMessage.read[this.uid] = true;
      this.afs
        .collection("Conversations")
        .doc(`${conversation.key}`)
        .update(conversation);
    }
    this.choice.emit(conversation);
  }
  toggleLimit() {
    this.limitTrigger = this.limitTrigger === "void" ? "show" : "void";
  }
}
// because i can't find where to import this...
type OrderByDirection = "desc" | "asc";
